import React from 'react';
import Flagship from '../../core/flagship';
import {connect} from 'react-redux';
import { Header, Segment } from 'semantic-ui-react';
import '../../styles/dashboard.scss';

class AdminFieldsContext extends React.Component {

    constructor(props) {
        super(props);
        this.fieldsContext = 'Unknown Context';
        this.state = {
            activeFields: [],
            inactiveFields: []
        }
    }

    componentWillMount() {
        setTimeout(Flagship.closeSidebarNav,500);
    }

    componentDidMount() {
        document.title =  "Flagship / Administer Fields";

        // Need to get fields list to render from API
    }

    componentWillUpdate(nextProps) {
        let fieldsContext = 'Unknown Context';

        if ( nextProps.params.splat === "client" ) {
            fieldsContext = "Client";
        } else if ( nextProps.params.splat === "rfp" ) {
            fieldsContext = "RFP";
        } else if ( nextProps.params.splat === "io" ) {
            fieldsContext = "IO";
        } else if ( nextProps.params.splat === "line_item" ) {
            fieldsContext = "Line Item (General)";
        } else if ( nextProps.params.splat === "io-product" ) {
            fieldsContext = "IO Product (General)";
        } else {
            Flagship.config.lineItemServices.map(function(item){

                let service;
                let context;

                if ( nextProps.params.splat.startsWith("line_item-") ) {
                    context = "Pricing Request Context";
                    service = nextProps.params.splat.replace("line_item-", "");
                } else  if ( nextProps.params.splat.startsWith("io-product-") ) {
                    context = "Insertion Order Context";
                    service = nextProps.params.splat.replace("io-product-", "");
                }
                if (item.value === service) {
                    fieldsContext = item.text + " (" + context + ")";
                }
            });
        }

        this.fieldsContext = fieldsContext;
    }

  render() {
      if (this.props.userRole === "admin") {
          return (
              <div className="fade-in">
                  <Header as="h1" className="white-text">Editing Fields: {this.fieldsContext}</Header>

                   <Segment>
                       <Header as="h3">Active Fields</Header>
                       {this.state.activeFields.length ?
                           this.state.activeFields.map(function() {

                           })
                           : null
                       }
                       <Header as="h3">Inactive Fields</Header>
                       {this.state.inactiveFields.length ?
                           this.state.inactiveFields.map(function() {

                           })
                           : null
                       }
                   </Segment>




                  <div id="footer">Flagship Administration</div>
              </div>
          );
      } else {
          return (
              <div className="fade-in">
                  <Header as="h1" className="white-text">Administration</Header>
                  <p className="white-text">You do not have access to administer Flagship.</p>
              </div>
          );
      }
  }
}

function mapStateToProps(state) {
    return {
        token: state.main.token,
        username: state.main.username,
        firstName: state.main.userFirstName,
        userRole: state.main.userRole,
        userId: state.main.userId
    };
}

export default connect(
    mapStateToProps,
    null
)(AdminFieldsContext);




// WEBPACK FOOTER //
// ./src/components/admin/AdminFieldsContext.js